export default {
	home: {
		name: "add goods"
	},
	page_out_trade_no: "Merchant Order Number"
};
